import {
  BaseFlowBlockSchema,
  FlowBlockType,
  FlowBlockValueTemplateDurationSchema,
  FlowProducedType,
} from 'flow-schema';
import { z } from 'zod';

import { SubFlowV2BlockConfigSchema } from '../subFlow/v2/config.js';

export const RepeatBlockConfigSchema = z.object({
  /**
   * The sub-flow to execute repeatedly
   */
  subFlow: SubFlowV2BlockConfigSchema,

  /**
   * A script whose value says whether to stop repeating
   */
  untilConditionScript: z.string().min(1, { message: 'Condition is required.' }),

  /**
   * Maximum number of times to execute the sub-flow
   */
  maximumIterations: z.number().int().positive(),

  /**
   * (Optional) A duration to wait between each execution of the sub-flow
   */
  iterationStepDuration: FlowBlockValueTemplateDurationSchema().optional(),
});

export const RepeatBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(FlowBlockType.Repeat),
  config: RepeatBlockConfigSchema,
  returnType: z.literal(FlowProducedType.Any).default(FlowProducedType.Any),
});

export type RepeatBlockConfig = z.infer<typeof RepeatBlockConfigSchema>;
export type RepeatBlock = z.infer<typeof RepeatBlockSchema>;
